import store from '../../../..';
import { TApiaFilter } from '../../../../../types';
import { TResponsiveTableRow } from '../../../../../components/common/generic/responsiveTable/types';
import { listActions } from '../../..';
import { makeListThunk } from '../../util/util';
import notifyRequiredFilters from '../../util/notifyRequiredFilters';

export type TTableRows = {
  rows: TResponsiveTableRow[];
};

const deleteFilters = makeListThunk<{
  filters?: TApiaFilter[] | undefined;
  areRequiredFilters?: boolean;
}>(
  'listSlice/deleteFilters',
  async ({ listId, avoidSynchronize }, thunkApi) => {
    const state = thunkApi.getState().listSlice.lists[listId];

    const emptyFilters: TApiaFilter[] =
      state.filters
        ?.map((currentFilter) => {
          if (
            ['D', 'date'].includes(currentFilter.type as string) ||
            currentFilter.isRange
          ) {
            return {
              ...currentFilter,
              deleteFiltersTimestamp: Date.now(),
              currentValue: '',
              filterToValue: '',
              error: undefined,
            };
          }
          if (currentFilter.options) {
            if (
              [
                'processesAdHocControl',
                'processesAdHocControl',
                'processFinalizeControl',
                'processPriorityControl',
                'processReasignControl',
                'processesRollbackControl',
                'processChangeDateControl',
              ].includes(window.listData[listId].component) &&
              currentFilter.id === 'cmbSta'
            ) {
              return currentFilter;
            }
            const newFilter: TApiaFilter = {
              ...currentFilter,
              currentValue: '',
              deleteFiltersTimestamp: Date.now(),
              options: currentFilter.options.map((option) => {
                if (option.selected) {
                  return {
                    ...option,
                    selected: false,
                  };
                }
                return option;
              }),
            };
            return newFilter;
          }
          if (
            currentFilter.id === 'txtRelTitle' ||
            currentFilter.id === 'txtInst'
          ) {
            const newFilter: TApiaFilter = {
              ...currentFilter,
              deleteFiltersTimestamp: Date.now(),
              currentValue: '',
              readonly: true,
            };
            return newFilter;
          }
          return {
            ...currentFilter,
            deleteFiltersTimestamp: Date.now(),
            currentValue: '',
          };
        })
        .filter((currentFilter) => {
          if (['entitiesMonitor'].includes(window.listData[listId].component)) {
            return !currentFilter.group;
          }
          return currentFilter;
        }) ?? [];

    const areRequiredFilters =
      state.filters?.some((filter) => filter.required) ?? false;

    if (areRequiredFilters || avoidSynchronize) {
      return {
        filters: notifyRequiredFilters(listId, emptyFilters),
        areRequiredFilters,
      };
    }

    await store.dispatch(
      listActions.filter({
        listId,
        filters: notifyRequiredFilters(listId, emptyFilters),
        filtersDeleted: true,
      }),
    );

    return { filters: emptyFilters };
  },
);

export default deleteFilters;
